<template>
	<!-- General -->
	<div class="card gen-card">
		<div v-if="account" class="card-body">
			<input type="file" class="d-none" name="avatar" accept="image/*" id="avatar" @change="uploadAvatar($event)" />

			<!-- Profile header -->
			<div class="gen-header">
				<span class="gen-avatar" role="button" title="Change avatar" @click="openDialog()">
					<Avatar :user="account" :size="96" />
					<span class="gen-avatar__edit"><font-awesome-icon :icon="['fas', 'pen']" /></span>
				</span>
				<div class="gen-identity">
					<h4 class="gen-name">{{ account.name }}</h4>
					<div class="gen-badges">
						<span v-if="account.role_id && account.role" class="gen-badge">{{ account.role.name }}</span>
						<span v-if="account.permissions" class="gen-badge gen-badge--muted">Custom permissions</span>
					</div>
					<a v-if="account.email" :href="'mailto:' + account.email" class="gen-email">
						<font-awesome-icon :icon="['fas', 'envelope']" class="me-1" />{{ account.email }}
					</a>
				</div>
				<router-link to="/account/information" class="gen-edit-btn">
					<font-awesome-icon :icon="['fas', 'pen']" /> Edit profile
				</router-link>
			</div>

			<!-- Details -->
			<div class="gen-details">
				<div class="gen-detail">
					<span class="gen-detail__label"><font-awesome-icon :icon="['fas', 'envelope']" class="me-2" />Email</span>
					<span class="gen-detail__value">{{ account.email || '—' }}</span>
				</div>
				<div class="gen-detail">
					<span class="gen-detail__label"><font-awesome-icon :icon="['fas', 'phone']" class="me-2" />Phone</span>
					<span class="gen-detail__value">{{ account.phone || '—' }}</span>
				</div>
				<div class="gen-detail">
					<span class="gen-detail__label"><font-awesome-icon :icon="['fas', 'user-tag']" class="me-2" />Role</span>
					<span class="gen-detail__value">{{ account.role ? account.role.name : '—' }}</span>
				</div>
				<div class="gen-detail gen-detail--full">
					<span class="gen-detail__label"><font-awesome-icon :icon="['fas', 'info-circle']" class="me-2" />About</span>
					<span class="gen-detail__value" :class="{ 'gen-detail__value--muted': !account.about }">
						{{ account.about || 'No description added yet.' }}
					</span>
				</div>
			</div>
		</div>
	</div>
	<!-- #General -->
</template>

<script>
import restApi from '../../api'
import { mapState } from 'vuex'
import Avatar from '@/components/user/Avatar'
import { handleErrors } from '../../actions/helpers'
export default {
	name: 'General',
	components: {
		Avatar,
	},
	data() {
		return {
			loading: false,
			avatar: '',
		}
	},
	computed: {
		...mapState(['account', 'storageUrl']),
	},
	updated() {
		this.avatar = this.account.avatar ? this.storageUrl + this.account.avatar : ''
	},
	methods: {
		uploadAvatar($event) {
			var form = new FormData()
			form.append('avatar', $event.target.files[0])
			form.append('id', this.account.id)

			const config = {
				headers: { 'content-type': 'multipart/form-data' },
			}

			restApi
				.post('/user/avatar', form, config)
				.then(({ data }) => {
					this.account.avatar = data
					this.avatar = data
					this.$swal.fire({
						icon: 'success',
						title: 'Avatar successfully updated',
						timer: 4000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, 'userAvatar'),
						timer: 6000,
					})
				})
		},
		openDialog() {
			document.getElementById('avatar').click()
		},
	},
}
</script>

<style scoped>
.gen-card {
	border: 1px solid #e6e8ec;
	border-radius: 12px;
	box-shadow: none;
}

/* Header */
.gen-header {
	display: flex;
	align-items: center;
	gap: 20px;
	padding-bottom: 20px;
	border-bottom: 1px solid #f1f3f5;
	flex-wrap: wrap;
}

.gen-avatar {
	position: relative;
	flex-shrink: 0;
	display: inline-flex;
	border-radius: 50%;
}

.gen-avatar__edit {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 28px;
	height: 28px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background: #111827;
	color: #fff;
	border: 2px solid #fff;
	border-radius: 50%;
	font-size: 11px;
	opacity: 0;
	transition: opacity 0.15s ease;
}

.gen-avatar:hover .gen-avatar__edit {
	opacity: 1;
}

.gen-identity {
	flex: 1;
	min-width: 0;
}

.gen-name {
	margin: 0 0 6px;
	font-size: 20px;
	font-weight: 700;
	color: #111827;
}

.gen-badges {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	margin-bottom: 8px;
}

.gen-badge {
	display: inline-block;
	padding: 2px 10px;
	font-size: 11px;
	font-weight: 700;
	border-radius: 999px;
	background: #e7f1ff;
	color: #0b5ed7;
}

.gen-badge--muted {
	background: #f1f3f5;
	color: #6b7280;
}

.gen-email {
	display: inline-flex;
	align-items: center;
	font-size: 13px;
	color: #6b7280;
	text-decoration: none;
}

.gen-email:hover {
	color: #2b6cff;
}

.gen-edit-btn {
	display: inline-flex;
	align-items: center;
	gap: 0.4rem;
	padding: 0.4rem 0.9rem;
	font-size: 0.85rem;
	font-weight: 600;
	border: 1px solid #e6e8ec;
	border-radius: 8px;
	background: transparent;
	color: #111827;
	text-decoration: none;
	transition: background 0.15s ease, border-color 0.15s ease;
	align-self: flex-start;
}

.gen-edit-btn:hover {
	background: #f3f5f9;
	border-color: #d1d5db;
	color: #111827;
}

/* Details grid */
.gen-details {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 16px 32px;
	padding-top: 20px;
}

.gen-detail {
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
}

.gen-detail--full {
	grid-column: 1 / -1;
}

.gen-detail__label {
	font-size: 0.72rem;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: #8a909c;
}

.gen-detail__value {
	font-size: 14px;
	color: #1f2937;
	word-break: break-word;
}

.gen-detail__value--muted {
	color: #9ca3af;
	font-style: italic;
}

@media (max-width: 640px) {
	.gen-details {
		grid-template-columns: 1fr;
	}
}
</style>
